import { captureException } from '@sentry/nextjs'
import { useMutation, UseMutationOptions } from 'react-query'
import { login } from 'utils/authApi'
import { Api } from 'types/Api'

export namespace Login {
  export type Response = { clientId: string }
  export type Variables = { email: string; password: string }
  export type Error = Api.Error
  export type Options = UseMutationOptions<Response, Error, Variables>
}

export const useLogin = (options?: Login.Options) => {
  const mutationFn = async ({ email, password }: Login.Variables) => login(email, password)

  const mutation = useMutation<Login.Response, Login.Error, Login.Variables>(mutationFn, {
    ...options,
    onError: (error) => {
      console.log(error)
      captureException(error)
    },
  })

  return { ...mutation, login: mutation.mutate }
}
